<template>
  <transition name="fade">
    <div class="sdf-popup" v-if="popupActive">
      <div class="sdf-popup-inner">
        <div class="sdf-popup-background" @click="switchPopupActive(false)"></div>
        <div class="sdf-popup-container">
          <feather-icon
            icon="XIcon"
            svgClasses="h-4 w-4"
            class="close-icon"
            @click="switchPopupActive(false)"
          />
          <div class="sdf-popup-title">
            <slot name="title"></slot>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"

export default {
  name: "sdfPopup",
  props: ['popupActive'],
  mixins: [SecureDataflowMixin],
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    switchPopupActive(val) {
      this.$emit("update:popupActive", val)
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/secure-dataflow/_variables.scss";

.close-icon {
  float: right;
  cursor: pointer;
}

.vs-button {
  padding: 4px 24px !important;
}

.sdf-popup-background {
  width: 100%;
  background: rgba(0,0,0,.4);
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 10;
  transition: all .25s ease;
  opacity: 1;
}

.sdf-popup-inner {
  left: 0;
  transition: all .2s;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
}

.sdf-popup-container {
  background: #21556F;
  z-index: 11;
  min-width: 200px;
  padding: 15px;
  max-width: calc(100% - 30px);
  max-height: calc(100% - 30px);
  border-radius: 6px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
